/**
 * Created by Alex Aguilar on 4/21/2016.
 */
'use strict';

angular.module('completeAir.version.filters', [])

    .filter("toUpper", [function(){
        return function(text){
            if(text != null){
                return text.toUpperCase();
            }
        }
    }])
    .filter("maxLength", [function(){
        return function(text,max){
            if(text != null){
                if(text.length > max){
                    return text.substring(0,max) + "...";
                }
            }
        }
    }])
    .filter("formatDateTime", ['$translate', function($translate){
        return function(date) {
            var newDate = date.toString();
            newDate = newDate.split(' ');

            var month = newDate[1].toUpperCase();

            return newDate[2] + " " + $translate.instant('OF') + " " + $translate.instant(month) + ', ';
        }
    }]);

/*
 .filter("capitalize", [function(){
 return function(text) {
 if(text != null){
 return text.substring(0,1).toUpperCase()+text.substring(1);
 }
 }
 }])
*/
